/*@flow*/
import history from 'lib/history';

export default function getId(resourceName: string): string | null {
  const { pathname } = history.getCurrentLocation();
  const match = pathname.match(new RegExp(`/${resourceName}/([^/?]+)/?`));
  return match && match[1];
}
